module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('h1', [_vm._v("Trials By " + _vm._s(_vm.enrollments))]), _vm._v(" "), (_vm.trials == false) ? _c('v-alert', {
    attrs: {
      "color": "info",
      "icon": "new_releases",
      "value": true
    }
  }, [_vm._v("\n          There are no trials for the " + _vm._s(_vm.enrollments) + " enrollment.\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": ""
    }
  }, _vm._l((_vm.trials), function(item) {
    return _c('v-card', {
      key: item.trialId,
      staticClass: "info"
    }, [_c('v-list', {
      staticClass: "listItems pa-0"
    }, [_c('v-list-tile', {
      staticClass: "pb-2 pt-2 pl-2"
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("folder")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(item.trialName)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "light": "",
        "flat": "",
        "ripple": "",
        "to": '/trials/' + item.trialId
      }
    }, [_c('right-icon', {
      attrs: {
        "color": item.active ? 'primary' : 'grey'
      }
    })], 1)], 1), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-btn', {
      staticClass: "red darken-3",
      attrs: {
        "dark": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.onDeleteTrial(item)
        }
      }
    }, [_c('v-icon', {
      staticClass: "text--lighten-1",
      attrs: {
        "small": "",
        "dark": ""
      }
    }, [_vm._v("delete")])], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-0",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-0 cyan--text text--darken-3 text-center",
    attrs: {
      "align-center": "",
      "depressed": "",
      "color": "cyan lighten-5",
      "dark": "",
      "to": '/trial/new'
    }
  }, [_vm._v("New Trial")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9b5fbb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trials/Enrollments/Singular.vue
// module id = 703
// module chunks = 1